<template>
    <div class="container">
        <div class="row text-center my-3">
            <div class="col">
                <h3>Instructions</h3>
                <div class="dropdown">
                    <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        Part 3: Installation
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <router-link class="dropdown-item" to="/instructions/assembly">Part 1: Assembly</router-link>
                        <router-link class="dropdown-item" to="/instructions/network">Part 2: WiFi Connection</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex my-2" :class="{'justify-content-between':isTabNameValid(tabLists,previousTab),'justify-content-end':!isTabNameValid(tabLists,previousTab)}">
            <a class="btn btn-primary" :href="'#'+previousTab" v-show="isTabNameValid(tabLists,previousTab)">Back</a>
            <a class="btn btn-primary" :href="'#'+nextTab" v-show="isTabNameValid(tabLists,nextTab)">Next</a>
            <router-link to="/register" replace v-show="isLastTab(tabLists,currentTab)">
                <button type="button" class="btn btn-primary">Next Part: Register</button>
            </router-link>
        </div>
        <tabs :options="{ useUrlFragment: false }" @changed="tabChanged">
            <tab id="outside" name="1.Outside">
                <div class="row align-items-center">
                    <div class="col-md-6 offset-md-3 align-self-center text-left">
                        <div class="thumbnail">
                            <div class="caption">
                                <ul class="fa-ul location-checklist">
                                    <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Outside</li>
                                    <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Close to WiFi
                                        source.</li>
                                    <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Sheltered</li>
                                    <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Shaded (Shade is
                                        important for the
                                        temperature sensor included in the device)</li>
                                    <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Decent airflow
                                        (Not windy, but not
                                        stagnant)</li>
                                    <li><span class="fa-li"><i class="fas fa-check-square"></i></span>Access to
                                        electrical power (Outlet
                                        within reach of cord or extension cord)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab id="direction" name="2.Direction">
                <div class="row align-items-center">
                    <div class="col align-self-center">
                        <div class="thumbnail">
                            <img src="/workshop/brochure/steps/step16.png" class="img-fluid"/>
                            <div class="caption">
                                <p>
                                    The front-facing board (green board) should face the WiFi source.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab id="cable" name="3.Cable">
                <div class="row align-items-center">
                    <div class="col align-self-center">
                        <div class="thumbnail">
                            <img src="/workshop/brochure/steps/step17.png" class="img-fluid"/>
                            <div class="caption">
                                <p>
                                    Use a "drip loop" to prevent water running down wires and into electronics.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab id="placement" name="4.Placement">
                <div class="row align-items-center">
                    <div class="col-md-12 col-lg-6 align-self-center">
                        <div class="thumbnail">
                            <img src="/workshop/brochure/steps/step18.png" class="img-fluid"/>
                            <div class="caption">
                                <p>Hang sensor using the integrated hang hole or hanger, or by using string (not
                                    included) to hang it
                                    from a suitable location, like a well covered branch.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6 align-self-center">
                        <div class="row">
                            <div class="col-12">
                                <img src="/workshop/brochure/steps/Installation1.png" class="img-fluid example-img"/>
                            </div>
                            <div class="col-12">
                                <img src="/workshop/brochure/steps/Installation2.png" class="img-fluid example-img"/>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
        <div class="d-flex my-2" :class="{'justify-content-between':isTabNameValid(tabLists,previousTab),'justify-content-end':!isTabNameValid(tabLists,previousTab)}">
            <a class="btn btn-primary" :href="'#'+previousTab" v-show="isTabNameValid(tabLists,previousTab)">Back</a>
            <a class="btn btn-primary" :href="'#'+nextTab" v-show="isTabNameValid(tabLists,nextTab)">Next</a>
            <router-link to="/register" replace v-show="isLastTab(tabLists,currentTab)">
                <button type="button" class="btn btn-primary">Next Part: Register</button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      previousTab: '',
      currentTab: 'video',
      nextTab: '',
      tabLists: ['outside', 'direction', 'cable', 'placement'],
    }
  },
  methods: {
    getPreviousAndNextTabName(array, tab) {
      let i = array.indexOf(tab)
      this.previousTab = array[i == 0 ? -1 : i - 1]
      this.currentTab = array[i]
      this.nextTab = array[i == array.length - 1 ? -1 : i + 1]
    },
    isLastTab(array, tab) {
      return array.indexOf(tab) == array.length - 1
    },
    isTabNameValid(array, tab) {
      return array.indexOf(tab) >= 0
    },
    tabChanged(selectedTab) {
      this.getPreviousAndNextTabName(this.tabLists, selectedTab.tab.id)
    },
  },
}
</script>

<style>
.location-checklist {
  font-size: 24px;
}

.example-img {
  padding: 10px;
}
</style>
